<template>
    <div>
        <b-modal size="lg" id="look-request" title="Değişiklik Talebini Değerledir" no-close-on-esc no-close-on-backdrop>
            <draft-price-change-request-decision v-model="request"></draft-price-change-request-decision>
            <template #modal-footer>
                <v-executer variant="success" text="Onayla" :loading="accepting" :disabled="rejecting || accepting" :action="acceptRequest"></v-executer>
                <v-executer variant="danger" text="Reddet" :loading="rejecting" :disabled="rejecting || accepting" :action="rejectRequest"></v-executer>
                <button class="btn btn-outline-primary" v-on:click="$hideModal('look-request')" :disabled="rejecting || accepting">Vazgeç</button>
            </template>
        </b-modal>

        <b-overlay :show="refreshing" opacity="0.2" rounded="sm">
            <div class="row">
                <div class="col-12 mb-2">
                    <h5 class="font-weight-bolder">Taslak Fiyat Bilgileri</h5>
                    <table class="table table-sm table-bordered mb-0">
                        <thead>
                            <tr>
                                <th class="w-50">Taslak Kodu</th>
                                <th class="w-50">Firma</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{requests.DraftOfferCode}}</td>
                                <td>{{requests.FirmName}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12 mb-2">
                    <h5 class="font-weight-bolder">Yakıt Bilgileri</h5>
                    <table class="table table-sm table-bordered mb-0">
                        <thead>
                            <tr>
                                <th>Yakıt Markası</th>
                                <th>Yakıt Tipi</th>
                                <th>Yakıt Şehri</th>
                                <th>Yakıt İlçesi</th>
                                <th>Yakıt Fiyatı (TL)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{requests.FuelGroupOfFuelBrand}}</td>
                                <td>{{requests.FuelGroupOfFuelPrice}}</td>
                                <td>{{requests.ProvinceOfFuelPrice}}</td>
                                <td>{{requests.DistrictOfFuelPrice}}</td>
                                <td>{{requests.FuelPrice}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="col-12">
                    <h5 class="font-weight-bolder">{{history ? 'Değişiklik Geçmişi' : 'Değişiklik Talepleri'}}</h5>
                    <div class="table-reponsive mb-0">
                        <table class="table table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th v-if="!history"></th>
                                    <th colspan="3" class="text-center bg-light-primary">Başlangıç</th>
                                    <th colspan="3" class="text-center bg-light-success">Bitiş</th>
                                    <th colspan="3" class="text-center bg-light-info">Tutar</th>
                                </tr>
                                <tr>
                                    <th class="text-center" v-if="!history">Durum</th>
                                    <th class="w-10">İl</th>
                                    <th class="w-10">İlçe</th>
                                    <th class="w-10">Mahalle</th>
                                    <th class="w-10">İl</th>
                                    <th class="w-10">İlçe</th>
                                    <th class="w-10">Mahalle</th>
                                    <th class="w-13">Tır/Treyler (TL)</th>
                                    <th class="w-13">Kırkayak (TL)</th>
                                    <th class="w-14">Kamyon (TL)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(item,index) in requests.PricesOfRoutes">
                                    <tr :key="'d_'+index">
                                        <td v-if="!history">
                                            <div class="d-flex align-items-center justify-content-center">
                                                <span class="material-icons-outlined text-success" v-if="getGeneralStatus(item)">check_circle</span>
                                                <span class="material-icons-outlined text-warning" v-else>hourglass_bottom</span>
                                            </div>
                                        </td>
                                        <td>{{item.StartProvinceName || '-'}}</td>
                                        <td>{{item.StartDistrictName || '-'}}</td>
                                        <td>{{item.StartNeighbourhoodName || '-'}}</td>
                                        <td>{{item.EndProvinceName || '-'}}</td>
                                        <td>{{item.EndDistrictName || '-'}}</td>
                                        <td>{{item.EndNeighbourhoodName || '-'}}</td>
                                        <td>{{item.TreylerRoutePriceStr || '-'}}</td>
                                        <td>{{item.KirkayakRoutePriceStr || '-'}}</td>
                                        <td>{{item.KamyonRoutePriceStr || '-'}}</td>
                                    </tr>
                                    <tr :key="'r_'+index">
                                        <td class="bg-light" colspan="150">
                                            <table class="table table-sm table-bordered">
                                                <thead>
                                                    <tr>
                                                        <!-- <th class="w-20">Değişiklik Nedeni</th> -->
                                                        <th :class="history ? 'w-20' : 'w-25'">Araç</th>
                                                        <th :class="history ? 'w-20' : 'w-25'">Talep Edilen Tutar (TL)</th>
                                                        <th :class="history ? 'w-20' : 'w-25'" class="text-nowrap">İstek Tarihi</th>
                                                        <th :class="history ? 'w-20' : 'w-25'" class="text-nowrap" v-if="history">Yanıtlanma Tarihi</th>
                                                        <th :class="history ? 'w-20' : 'w-25'">Açıklama</th>
                                                        <th>Durum</th>
                                                        <th v-if="!history">İşlem</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(req,ci) in item.AllChangeRequests" :key="'req_'+ci"> 
                                                        <!-- <td><strong>{{req.Reason || "-"}}</strong></td> -->
                                                        <td>{{req.Type == 'TREYLER' ? 'TIR/TREYLER' : req.Type}}</td> 
                                                        <td>
                                                            <template v-if="req.ReasonCode == 'ROUTE_ERROR'">
                                                                <strong>Talep Edilen Rota: </strong>
                                                                <template v-if="req.StartProvinceName">{{req.StartProvinceName}}</template>
                                                                <template v-if="req.StartDistrictName">, {{req.StartDistrictName}}</template>
                                                                <template v-if="req.StartNeighbourhoodName">, {{req.StartNeighbourhoodName}}</template>
                                                                <template v-if="req.EndProvinceName"> -> {{req.EndProvinceName}}</template>
                                                                <template v-if="req.EndDistrictName">, {{req.EndDistrictName}}</template>
                                                                <template v-if="req.EndNeighbourhoodName">, {{req.EndNeighbourhoodName}}</template>
                                                            </template>
                                                            <template v-else-if="req.ReasonCode == 'CHANGE_PRICE'">
                                                                {{req.PriceStr}}
                                                            </template>
                                                            <template v-else>-</template>
                                                        </td>
                                                        <td class="text-nowrap">{{req.CreatedDate || '-'}}</td>
                                                        <td class="text-nowrap" v-if="history">{{req.ActionDate || '-'}}</td>
                                                        <td>{{req.Description || "-"}}</td>
                                                        <td class="text-center align-middle">
                                                            <span class="material-icons-outlined text-warning" v-if="req.Status == 0">hourglass_bottom</span>
                                                            <span class="material-icons-outlined text-success" v-else-if="req.Status == 1">check_circle</span>
                                                            <span class="material-icons-outlined text-danger" v-else-if="req.Status == 2">cancel</span>
                                                        </td>
                                                        <td v-if="!history">
                                                            <button class="btn btn-sm btn-success" v-on:click="lookRequest(item,req)">Değerlendir</button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import randomatic from 'randomatic'
import GoogleMaps from '@/utilities/google-maps'
import DraftPriceChangeRequestDecision from './DraftPriceChangeRequestDecision.vue'
import CalculatePriceApi from '@/api/calculate-price'
import {BOverlay} from 'bootstrap-vue'

export default {
    components:{
        DraftPriceChangeRequestDecision,
        BOverlay
    },
    inject:['tableRefresh'],
    props:{
        value:Object,
        history:Boolean
    },
    data(){
        return{
            requests:{},
            accepting:false,
            rejecting:false,
            refreshing:false,
            request:{
                CustomerDraftOfferPriceChangeRequestId:null,
                StartProvinceId:null,
                StartDistrictId:null,
                StartNeighbourhoodId:null,
                EndProvinceId:null,
                EndDistrictId:null,
                EndNeighbourhoodId:null,
                StartProvinceName:null,
                StartDistrictName:null,
                StartNeighbourhoodName:null,
                EndProvinceName:null,
                EndDistrictName:null,
                EndNeighbourhoodName:null,
                Km:null,
                PriceStr:null,
                Price:null,
                Status:null,
                Type:null,
                Reason:null,
                ReasonCode:null,
                Original:{
                    StartProvinceName:null,
                    StartDistrictName:null,
                    StartNeighbourhoodName:null,
                    EndProvinceName:null,
                    EndDistrictName:null,
                    EndNeighbourhoodName:null,
                    PriceStr:null,
                }
            }
        }
    },
    created(){
        this.requests = this.configureDetail(this.value)
    },
    methods:{
        clearForm(){
            this.request.CustomerDraftOfferPriceChangeRequestId = null
            this.request.StartProvinceId = null
            this.request.StartDistrictId = null
            this.request.StartNeighbourhoodId = null
            this.request.EndProvinceId = null
            this.request.EndDistrictId = null
            this.request.EndNeighbourhoodId = null
            this.request.StartProvinceName = null
            this.request.StartDistrictName = null
            this.request.StartNeighbourhoodName = null
            this.request.EndProvinceName = null
            this.request.EndDistrictName = null
            this.request.EndNeighbourhoodName = null
            this.request.Km = null
            this.request.PriceStr = null
            this.request.Price = null
            this.request.Status = null
            this.request.Type = null
            this.request.Reason = null
            this.request.ReasonCode = null
            this.request.Original.StartProvinceName = null
            this.request.Original.StartDistrictName = null
            this.request.Original.StartNeighbourhoodName = null
            this.request.Original.EndProvinceName = null
            this.request.Original.EndDistrictName = null
            this.request.Original.EndNeighbourhoodName = null
            this.request.Original.PriceStr = null
        },
        configureDetail(data){
            data.PricesOfRoutes = data.PricesOfRoutes.map(d=>{ 
                let otherChangeRequests = d.OtherChangeRequests || []
                let routeChangeRequests = d.RouteChangeRequests || []
                let kamyonChangeRequests = d.KamyonChangeRequests || []
                let treylerChangeRequests = d.TreylerChangeRequests || []
                let kirkayakChangeRequests = d.KirkayakChangeRequests || []
                
                let allChangeRequests = []
                allChangeRequests.push(...otherChangeRequests.map(c=>{return{...c,Type:"OTHER"}}))
                allChangeRequests.push(...routeChangeRequests.map(c=>{return{...c,Type:"ROUTE_ERROR"}}))
                allChangeRequests.push(...kamyonChangeRequests.map(c=>{return{...c,Type:"KAMYON"}}))
                allChangeRequests.push(...treylerChangeRequests.map(c=>{return{...c,Type:"TREYLER"}}))
                allChangeRequests.push(...kirkayakChangeRequests.map(c=>{return{...c,Type:"KIRKAYAK"}}))

                return{
                    ...d,
                    Id:randomatic("A0",10),
                    AllChangeRequests:allChangeRequests,
                    ShowHistory:false,
                    Status:0
                } 
            })
            return data
        },
        getGeneralStatus(item){
            return item.AllChangeRequests.length == item.AllChangeRequests.filter(c=> c.Status == 1).length ? true : false
        },
        lookRequest(item,req){
            this.clearForm()
            this.request.CustomerDraftOfferPriceChangeRequestId = req.CustomerDraftOfferPriceChangeRequestId
            this.request.StartProvinceId = req.StartProvinceId
            this.request.StartDistrictId = req.StartDistrictId
            this.request.StartNeighbourhoodId = req.StartNeighbourhoodId
            this.request.EndProvinceId = req.EndProvinceId
            this.request.EndDistrictId = req.EndDistrictId
            this.request.EndNeighbourhoodId = req.EndNeighbourhoodId
            this.request.StartProvinceName = req.StartProvinceName
            this.request.StartDistrictName = req.StartDistrictName
            this.request.StartNeighbourhoodName = req.StartNeighbourhoodName
            this.request.EndProvinceName = req.EndProvinceName
            this.request.EndDistrictName = req.EndDistrictName
            this.request.EndNeighbourhoodName = req.EndNeighbourhoodName
            this.request.PriceStr = req.PriceStr
            this.request.Type = req.Type
            this.request.Status = req.Status
            this.request.Reason = req.Reason
            this.request.ReasonCode = req.ReasonCode
            this.request.Original.StartProvinceName = item.StartProvinceName
            this.request.Original.StartDistrictName = item.StartDistrictName
            this.request.Original.StartNeighbourhoodName = item.StartNeighbourhoodName
            this.request.Original.EndProvinceName = item.EndProvinceName
            this.request.Original.EndDistrictName = item.EndDistrictName
            this.request.Original.EndNeighbourhoodName = item.EndNeighbourhoodName
            if(req.Type == "TREYLER") this.request.Original.PriceStr = item.TreylerRoutePriceStr
            if(req.Type == "KAMYON") this.request.Original.PriceStr = item.KamyonRoutePriceStr
            if(req.Type == "KIRKAYAK") this.request.Original.PriceStr = item.KirkayakRoutePriceStr
            this.$showModal('look-request')
        },
        calculateNewKM(req){
            let startRoutes = []
            if(req.StartProvinceName) startRoutes.push(req.StartProvinceName)
            if(req.StartDistrictName) startRoutes.push(req.StartDistrictName)
            if(req.StartNeighbourhoodName) startRoutes.push(req.StartNeighbourhoodName)
            
            let endRoutes = []
            if(req.EndProvinceName) endRoutes.push(req.EndProvinceName)
            if(req.EndDistrictName) endRoutes.push(req.EndDistrictName)
            if(req.EndNeighbourhoodName) endRoutes.push(req.EndNeighbourhoodName)
            
            const google = new GoogleMaps()
            google.GetDistance(startRoutes.join(','),endRoutes.join(','),false,false,0).then(res=>{
                if(res.rows[0].elements[0].status == "OK"){
                    this.request.Km = Math.ceil(res.rows[0].elements[0].distance.value/1000)
                }
            })
        },
        acceptRequest(){
            this.accepting = true
            this.request.Status = 1
            this.request.Price = this.request.PriceStr?.replaceAll('.','')?.replace(',','.')
            CalculatePriceApi.DraftPriceOperation.Action(this.request).then(res=>{
                this.$result(res)
                this.accepting = false
                if(res.data.Success){
                    this.tableRefresh()
                    this.$hideModal('look-request')
                    this.refresh()
                }
            }).catch(err=>{
                this.$result(null,err)
                this.accepting = false
            })
        },
        rejectRequest(){
            this.rejecting = true
            this.request.Status = 2
            this.request.Price = this.request.PriceStr?.replaceAll('.','')?.replace(',','.')
            CalculatePriceApi.DraftPriceOperation.Action(this.request).then(res=>{
                this.$result(res)
                this.rejecting = false
                if(res.data.Success){
                    this.refresh()
                    this.tableRefresh()
                    this.$hideModal('look-request')
                }
            }).catch(err=>{
                this.$result(null,err)
                this.rejecting = false
            })
        },
        refresh(){
            this.refreshing = true
            CalculatePriceApi.DraftPriceOperation.GetCustomerChangeRequest(this.value.PreparedDraftOfferId).then(res=>{
                if(res.data.Success){
                    this.requests = this.configureDetail(res.data.Data)
                    if(this.requests?.PricesOfRoutes?.length == 0) this.$hideModal('change-request')
                    this.refreshing = false
                }
            }).catch(err=>{
                this.refreshing = false
            })
        }
    }
}
</script>

<style>

</style>